import { render, staticRenderFns } from "./myexamination.vue?vue&type=template&id=5603f9ac&scoped=true"
import script from "./myexamination.vue?vue&type=script&lang=js"
export * from "./myexamination.vue?vue&type=script&lang=js"
import style0 from "./myexamination.vue?vue&type=style&index=0&id=5603f9ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603f9ac",
  null
  
)

export default component.exports